import tableRooms from './tableRooms';
import tableYoutubeCategory from './tableYoutubeCategory';

export default {
  title: 'Youtube Categories Management',
  attributeName: 'youtubeCategories',
  getURL: 'mainHubs/mainHubId/youtube/categories',
  createURL: 'mainHubs/mainHubId/youtube/categories',
  updateURL: 'mainHubs/mainHubId/youtube/categories',
  removeURL: 'mainHubs/mainHubId/youtube/categories',
  sessionParams: ['mainHubId'],
  idAttribute: 'id',
  tableConfig: tableYoutubeCategory,
  removeNameField:'name',
  removeText:'You are about to remove the category with name ##name##.',
  noArea: true,
  autoUpdate: true,
};

